import ApiService from 'Services/config';


export const LoginService = (body) => {
    return ApiService.post('admin/login', body)
}
export const verifyOtp = (emailId, OTP, SessionID, otp_route) => {
    return ApiService.post(`admin/login/mfa/verify-otp`, { emailId, OTP, SessionID, otp_route: otp_route })
}
export const getAdminUsers = () => {
    return ApiService.get('admin/users/all')
}
export const UpdateAdminUsers = (adminUserId, body) => {
    return ApiService.patch(`admin/${adminUserId}/user`, body)
}
export const addAdminUser = (data) => {
    return ApiService.post('admin/create/user', data)
}
export const DeleteAdminUser = (adminUserId) => {
    return ApiService.delete(`admin/${adminUserId}/user`)
}

// ----------All Customers--------------

export const AllUsers = () => {
    return ApiService.get(`admin/customers/all`)
}
export const AllUsersRefresh = () => {
    return ApiService.get(`admin/customers/all/refresh`)
}
export const getCustomerRoles = () => {
    return ApiService.get(`admin/customer/roles`)
}
export const AssignRole = (CustomerId, body) => {
    return ApiService.patch(`admin/customer/${CustomerId}/assign-role`, body)
}
export const GetPermissions = (RoleId) => {
    return ApiService.get(`admin/customer/roles/permissions?roleId=${RoleId}`)
}
export const updatePermissions = (body) => {
    return ApiService.patch(`/admin/customer/roles/update-permissions`, body)
}
export const getApproveRequests = (status) => {
    return ApiService.get(`admin/approval-requests/status?approvalStatus=${status}`)
}
export const updateRejectStatus = (body) => {
    return ApiService.patch(`/admin/approval-request/update-status`, body)
}
export const GetLogs = (offset) => {
    return ApiService.get(`/admin/logs?Offset=${offset}`)
}
export const GetLogsSearch = (offset, data) => {
    return ApiService.post(`/admin/logs?Offset=${offset}`, data)
}
export const getNotificationCount = () => {
    return ApiService.get(`/admin/notifications/unread`)
}

export const getNotification = (offset, body) => {
    return ApiService.post(`/admin/notifications?Offset=${offset}`, body)
}
export const updateUnreadNotification = () => {
    return ApiService.put(`/admin/notifications/read`)
}
export const updatePlaceID = (userId, body) => {
    return ApiService.patch(`/admin/user/${userId}/update-placeId`, body)
}
export const unlockUser = (body) => {
    return ApiService.patch(`/admin/customer/unlock`, body)
}
export const lockUserApi = (body) => {
    return ApiService.patch(`/admin/customer/lock`, body)
}
export const deleteUser = (id) => {
    return ApiService.delete(`/admin/user/${id}`)
}

export const getSettings = () => ApiService.get('/admin/configurables')

export const updateSettings = (configId, body) => ApiService.patch(`/admin/${configId}/configurables`, body)

export const getFaq = (body) => ApiService.get(`/admin/FAQs`, body)

export const AddFaq = (body) => ApiService.post(`/admin/FAQs`, body)

export const deleteFaqs = (id) => ApiService.delete(`/admin/FAQs/${id}`)
export const UpdateFaqs = (id, body) => ApiService.patch(`/admin/FAQs/${id}`, body)
export const getMetrics = (body) => ApiService.post(`admin/site-metrics`, body)


// ----------------Notification Settings --------------

export const NotificationSettings = () => ApiService.get(`admin/customer/notifications/permissions`)

export const NotificationSettingsUpdate = (body) => ApiService.patch(`admin/customer/notifications/update-permissions`, body)


export const CommonNotificationadd = (body) => ApiService.post(`admin/highlights/add`, body)
export const getHighlights = () => ApiService.get(`admin/highlights`)
export const deleteHighlight = (id) => ApiService.delete(`admin/highlights/${id}`)
